import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SurveyForm } from 'src/app/shared/models/survey/surveyForm';
import { Subscription } from 'rxjs';
import { SurveyService } from 'src/app/shared/services/survey.service';
import { AccessibilityService } from 'src/app/shared/services/accessibility.service';

@Component({
  selector: 'survey-confirmation',
  templateUrl: './survey-confirmation.component.html',
  styleUrls: ['./survey-confirmation.component.scss'],
  standalone: false
})
export class SurveyConfirmationComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private hasAnnounced: boolean = false;
  @Input()
  inPreviewMode: boolean = false;
  survey: SurveyForm;

  private readonly DEFAULT_CONFIRMATION_MESSAGE: string = 'Thank you for completing the survey.';

  constructor(
    private surveyService: SurveyService,
    private accessibilityService: AccessibilityService
  ) {}

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    if (!this.inPreviewMode) {
      this.subscription = this.surveyService.survey.subscribe((result) => {
        if (result) {
          this.survey = result;
          this.surveyService.setSurveyForm();
          this.announceConfirmation();
        }
      });
    } else {
      this.subscription = this.surveyService.surveyPreview.subscribe((result) => {
        if (result) {
          this.survey = result;
          this.announceConfirmation();
        }
      });
    }
  }

  /**
   * Announces the submission result to screen readers.
   *
   * This cannot run from a lifecycle hook: the survey arrives asynchronously, so the
   * confirmation text is not known when the view first renders. Without it a screen reader
   * only hears the route title, which is the same title as the survey page the user just
   * left, so nothing conveys that the response was submitted (WCAG 2.1 SC 4.1.3).
   */
  private announceConfirmation() {
    if (this.hasAnnounced) {
      return; //the subject can emit more than once. Only the first arrival is news
    }

    if (!this.inPreviewMode && !this.survey?.hasCompleted) {
      return; //setSurveyForm is redirecting away. This is not the confirmation
    }

    this.hasAnnounced = true;
    //read the title directly rather than via hasConfirmationTitle: the survey and evaluation
    //models disagree on whether an empty string counts as a title, and an empty announcement
    //would be dropped, leaving the page silent
    this.accessibilityService.talk(
      this.survey?.confirmationTitle?.trim() || this.DEFAULT_CONFIRMATION_MESSAGE
    );
  }
}
